import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <div className="flex-grow flex flex-col justify-center" data-id="element-175" data-mp="9wse4r2d6rwa">
      <About data-id="element-176" data-mp="9ymyo49q4hzu" />
    </div>;
}